import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAlarmTypes } from "../../api/get-alarm-types";

export const getAlarmTypesAction = createAsyncThunk(
  "alarms/getAlarmTypes",
  async (_, { rejectWithValue }) => {
    try {
      return await getAlarmTypes();
    } catch (error: any) {
      return rejectWithValue(error.response?.data);
    }
  }
);
